// generated from 15_662 samples

import { z } from "zod";
import { common } from "../common";
import { filterGetBaseSchema } from "./filterGetBaseSchema";

export const lastReceivedPushCampaignFilterGetSchema = z.object({
  ...filterGetBaseSchema.shape,
  filter_key: z.literal("last_received_push_campaign_filter"),
  comparison_key: z.enum([
    "6", // 9_788 (62.50%)
    "12", // 5_475 (34.96%)
    "4", // 262 (1.67%)
    "5", // 114 (0.73%)
    "3", // 23 (0.15%)
  ]),
  display_name: z.string(),
  // undefined: 11_916 (76.08%), defined 3_746 (23.92%)
  raw_value: z
    .union([
      // number samples: 3_050 (81.42%)
      // integer: 904 (29.64%)
      // avg: 0.95, min: 0, max: 182
      z.number().min(0),
      // string samples: 696 (18.58%)
      common.date,
    ])
    .optional(),
  value: z.union([
    // number samples: 10_062 (64.24%)
    // integer: 1_756 (17.45%)
    // avg: 1.22, min: 0, max: 365
    z.number().min(0),
    // string samples: 5_600 (35.76%)
    common.date,
  ]),
  varies_by_app_group: z.literal(false),
});
